module.exports = __webpack_public_path__ + "img/staff_text.38f1a8b3.svg";